import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { View } from 'foundations-components/components/View';
import { EcosystemReviewPopover } from 'marketplace-ui-reviews/components/wizard/EcosystemReviewPopover';
import EcosystemReview from 'marketplace-ui-reviews/records/Review';
import { ReviewTagsInput } from 'trellis-ecosystem';
import UsageTracker from '../../../utils/UsageTracker';
import { AcademyRatingsTypes } from '../../../constants/RatingsAndReviewConstants';
import { chirpEnumToString } from 'academy-common-lib/utils/chirp';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RatingsPopoverButton = ({
  children,
  contentId,
  displayPopover,
  handleOnClose,
  handleOnSuccess,
  header,
  previousReview,
  rating,
  ratingsReviewGroupKey,
  reviewTags,
  reviewType,
  visibility
}) => {
  const previousReviewRecord = previousReview ? new EcosystemReview(Object.assign({}, previousReview, {
    replies: null
  })) : undefined;
  const handleReviewFormatter = review => {
    const newReview = Object.assign({}, review);
    newReview.ratings.OVERALL = rating;
    return newReview;
  };
  const isReviewEditing = !!previousReviewRecord;
  const trackingContentType = reviewType === AcademyRatingsTypes.ACADEMY_COURSE ? 'TRACK' : reviewType === AcademyRatingsTypes.ACADEMY_LESSON ? 'LESSON' : 'SHORT_FORM_CONTENT';
  const onOptionClick = () => UsageTracker.trackStandalone('Content Interaction', {
    action: 'ratings-tag-option-clicked',
    contentId,
    contentType: trackingContentType,
    visibility: chirpEnumToString(visibility)
  });
  return /*#__PURE__*/_jsx(EcosystemReviewPopover, {
    bodyContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.ratingsAndReview.selectAll"
      }), /*#__PURE__*/_jsx(View, {
        as: "div",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(ReviewTagsInput, {
          fieldKey: ratingsReviewGroupKey,
          onClick: onOptionClick,
          options: reviewTags
        })
      })]
    }),
    editedReview: previousReviewRecord,
    errorAlertTitle: I18n.text('learningCenter.ratingsAndReview.alerts.errors.title'),
    headerContent: header,
    offeringId: contentId,
    onClose: handleOnClose,
    onSuccess: handleOnSuccess,
    overrideSubmitValidation: isReviewEditing,
    popoverProps: {
      open: displayPopover,
      inlineSize: '400px'
    },
    requireEditReason: false,
    reviewFormatter: handleReviewFormatter,
    reviewType: reviewType,
    submitButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.ratingsAndReview.submit"
    }),
    successAlertMessage: " ",
    successAlertTitle: I18n.text('learningCenter.ratingsAndReview.alerts.success.title'),
    validationSchema: {
      ratings: {
        [ratingsReviewGroupKey]: {
          required: false
        }
      }
    },
    children: children
  });
};
export default RatingsPopoverButton;